import { ContentFlexComponent, ContentProps } from "components/flexComponents/Content/typings";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";

/**
 * ContentComponent is the base interface for any implementation that wants to show "Content".
 * A "Content" generally consists of HTML strings that we parse through with the best of
 * our abilities and display as is on the page. Mainly, we do not control the
 * content of a Content, we simply put them in the page.
 */
export abstract class ContentComponent {
  public fmId: number;
  public fmTitleId?: number;
  public id: string;
  public title: string;
  public text: string;
  public abstract getId: () => string;
  public abstract shouldRender: () => boolean;
  public readonly flexComponent: ContentFlexComponent;
  public keyHelper: ItemKeyHelper;

  protected constructor(module: ContentFlexComponent) {
    this.fmId = module.fmId;
    this.fmTitleId = module.fmTitleId;
    this.flexComponent = module;
  }

  public abstract generate(props: ContentProps): JSX.Element | null;

  public getEditorialItemClassName: () => string;
}
